<app-documents-table [borrowerId]="borrowerId" [dealId]="dealId" />
